import { createSelector } from 'reselect';
import _ from 'lodash';

// formHistory selectors
export const getFormHistory = state => state.cards.formHistory;

// customizationBar selectors
export const getAddressingOptionStatus = state => state.cards.cardCustomizationBar.hasRecipientAddressing;
export const getCustomizationErrorsByElementUUID = state => state.cards.cardCustomizationBar.errorsByElementUUID;

export const getCustomizationHasErrors = createSelector(
  getCustomizationErrorsByElementUUID,
  (errorsByElementUUID) => {
    if (errorsByElementUUID && errorsByElementUUID.length > 0) {
      return true;
    }
    return false;
  }
);

// recipients selectors
const getGuestGroups = state => state.guestList.guests.byId;
export const getSelectedGuestIds = state => state.cards.recipients.selectedGuestIds;
export const getInvitedGuestsCount = state => state.guestList.guests.orderedIds.length || 0;

// get the selected guests from guestGroups
// Check that intersection for missing emails
export const getIsGuestListMissingEmail = createSelector(
  getGuestGroups,
  getSelectedGuestIds,
  (guestGroups, selectedGuestIds) => _.some(
    selectedGuestIds,
    id => (guestGroups[id] && guestGroups[id].email_address === null)
      || (guestGroups[id] && guestGroups[id].email_address === '')
  )
);

// TODO: clean up this name, because it's returning array, it's not returning a number
export const getGuestGroupsMissingEmailCount = createSelector(
  getGuestGroups,
  getSelectedGuestIds,
  (guestGroups, selectedGuestIds) => _.filter(
    selectedGuestIds,
    id => guestGroups[id] && (guestGroups[id].email_address === null || guestGroups[id].email_address === '')
  )
);



// WEBPACK FOOTER //
// ./src/cards/selectors/Customization.js